<template>
  <div class="order-payway">
    <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell clickable @click="radio = '1'">
          <p class="flex jc-sb aic">
            <i class="iconfont icon-weixinzhifu f24" style="color: #09bb07"></i>
            <van-radio
              icon-size="16px"
              slot="right-icon"
              name="1"
              checked-color="#c03131"
            />
          </p>
        </van-cell>
        <van-cell clickable @click="radio = '2'">
          <p class="flex jc-sb aic">
            <i class="iconfont icon-iconzhi01 f20" style="color: #1296db"></i>
            <van-radio
              icon-size="16px"
              slot="right-icon"
              name="2"
              checked-color="#c03131"
            />
          </p>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div class="submit pt-30 pb-10 fcc">
      <van-button
        class="button"
        type="danger"
        size="large"
        @click="$emit('toPay', radio)"
        >支付 {{ money }}</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["allFee"],
  computed: {
    money() {
      return (this.allFee / 100).toFixed(2);
    },
  },
  data() {
    return {
      radio: "1",
    };
  },
  methods: {},
};
</script>

<style lang="less">
.order-payway .van-button--large {
  width: 90%;
}
</style>

<style scoped lang="less">
.displays {
  .mongolian {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: black;
    opacity: 0.3;
    z-index: 10;
  }
  .low {
    height: 235px;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 999;
    .submit {
      width: 100%;
      padding: 0 20px;
      .button {
        margin-top: 32px;
      }
      .van-button--danger {
        background-color: #c03131;
        border: 1px solid #c03131;
      }
    }
    .choose {
      height: 50px;
      padding-left: 100px;
      padding-right: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        color: #191a1b;
        font-size: 15px;
      }
      .van-icon {
        color: #b3b5b8;
        font-size: 16px;
      }
    }
    .van-cell__title {
      span {
        font-size: 15px;
        color: #191a1b;
      }
    }
    .van-cell__left-icon {
      margin-right: 12px;
    }
  }
}
</style> 